const PATH = 'fe.pages.measure.view.examples_and_notes';

const messages = {
  summaryError: {
    key: `${PATH}.summary_error`,
    defaultValue:
      'Please complete all required fields in order to see your observation summary.'
  }
};

export default messages;
